export interface DashboardMountGateInput {
  hasTimelineContent: boolean
  isAccessRestricted?: boolean
}

/**
 * Determines whether `<DashboardContainer />` should mount on the main Dashboard route.
 *
 * An unrestricted user with 0 goals gets `<DashboardCanvas goals={[]} />` (the "AI Magic is ready" prompt).
 * A restricted user (`isAccessRestricted === true`) must always mount `<DashboardContainer />`, even with
 * 0 goals, so that the container's scoped empty-state and view-switcher remain accessible.
 */
export const shouldMountDashboardContainer = ({
  hasTimelineContent,
  isAccessRestricted = false,
}: DashboardMountGateInput): boolean => {
  return hasTimelineContent || isAccessRestricted
}
